<template>
    <div class="app">
        <Header label="Help" currentpath="video"></Header>
        <section class="all-v">
            <div class="container">
                <div class="row">
                    <div class="col-2 text-left">
                        <router-link to="/help" class="back-btn" v-if="isBack">
                            <i class="fa fa-angle-left"></i> <span class="d-none d-sm-inline">Back</span>
                        </router-link>
                    </div>
                    <div class="col-8">
                        <h1>WaterGuru Help</h1>
                    </div>
                    <div class="col-2 text-right">
                        <a class="print-btn" @click="print" v-if="isPrint">
                            <span class="d-none d-sm-inline">Print</span> <i class="fa fa-print"></i>
                        </a>
                    </div>
                </div>
                <div v-if="$route.name !== 'Instruction'">
                    <div class="flex" id="help-menu">
                        <div class="category-item">
                            <router-link to="/help" :class="{active: !category}">View All</router-link>
                        </div>
                        <div class="category-item">
                            <router-link :to="{path: '/help', query: {category:'start'}}" :class="{active: category === 'start'}">Getting Started</router-link>
                        </div>
                        <div class="category-item">
                            <router-link :to="{path: '/help', query: {category:'refill'}}" :class="{active: category === 'refill'}">Refilling</router-link>
                        </div>
                        <div class="category-item">
                            <router-link :to="{path: '/help', query: {category:'clean'}}" :class="{active: category === 'clean'}">Emptying & Cleaning</router-link>
                        </div>
                    </div>
                </div>
                <router-view class="pb-5 pb-sm-0"></router-view>
            </div>
            <w-version/>
        </section>
    </div>
</template>

<script>
import Header from '../Header'

export default {
    name: 'help',
    data () {
        return { loginUserAttr: {} }
    },
    computed: {
        category () {
            return this.$route.query.category
        },
        isBack () {
            return this.$route.name === 'Instruction'
        },
        isPrint () {
            return this.$route.name === 'Instruction'
        }
    },
    components: {
        Header
    },
    methods: {
        print () {
            window.print()
        }
    }
    // mounted () {
    //     if (typeof window.zE !== 'undefined') {
    //         window.zE(() => {
    //             window.zE.show()
    //             const loginUserAttr = this.$store.getters['auth/attributes']
    //             const userName = loginUserAttr.given_name + ' ' + loginUserAttr.family_name
    //             const userEmail = loginUserAttr.email
    //             window.zE.identify({ name: userName, email: userEmail })
    //         })
    //     }
    // },
    // destroyed () {
    //     window.zE(() => window.zE.hide())
    // }
}
</script>

<style scoped>
    ul {
        list-style-type: none;
    }

    .app {
        height: 100%;
        padding-top: 85px;
    }

    .all-v {
        height: calc(100% - 85px);
        overflow-y: scroll;
        overflow-x: hidden;
    }

    .all-v::-webkit-scrollbar {
        width: 5px;
        opacity: 0;
    }

    .all-v::-webkit-scrollbar-thumb {
        -webkit-border-radius: 10px;
        border-radius: 10px;
        opacity: 0.5;
        background: #CCC;
    }

    .all-v {
        width: 100%;
        font-family: "Nunito", sans-serif;
        font-weight: 600;
        color: #2fc2ef;
        background-color: #fff;
    }

    .all-v h1 {
        text-align: center;
        margin: 30px 0;
        font-size: 50px;
        font-weight: 600;
        font-family: "Nunito", sans-serif;
        color: #2fc2ef;
    }

    .container {
        max-width: 1060px;
        width: 100%;
        padding: 0 10px;
        margin: 0 auto;
    }

    .flex {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        padding-bottom: 35px;
    }

    a:hover {
        color: #fff;
        text-decoration: none;
    }

    .back-btn,
    .print-btn {
        color: #2fc2ef;
        cursor: pointer;
        margin-top: 30%;
        display: block;
        font-size: 20px;
    }

    .back-btn > i,
    .print-btn > i {
        font-size: 30px;
    }

    .back-btn:hover,
    .print-btn:hover {
        color: #2fc2ef;
    }

    .back-btn > span {
        position: absolute;
        margin-left: 5px;
        margin-top: 1px;
    }

    .flex .category-item a {
        color: #898989;
        font-size: 24px;
    }

    .flex .category-item a.active {
        color: #2fc2ef;
    }

    .category-item {
        margin-left: 42px;
        margin-right: 42px;
    }

    @media (max-width: 768px) {
        .modal-ticket {
            margin: 20px !important;
        }

        .all-v {
            width: 100%;
            overflow-x: unset;
            overflow-y: unset;
        }
    }

    @media (max-width: 576px) {
        .all-v h1 {
            font-size: 25px;
            margin-top: 10px;
        }

        .flex .category-item a {
            color: #898989;
            font-size: 18px;
        }
    }
</style>
